import { Injectable, Injector } from '@angular/core'
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  config: Record<string, string | Record<string, string>>;

  constructor(private injector: Injector) { }

  load(url: string) {
    const injectHttp = this.injector.get(HttpClient);
    return new Promise((resolve) => {
      injectHttp.get(url).subscribe((config) => {
        this.config = config as Record<string, string | Record<string, string>>;
        resolve({});
      });
    });
  }


  getUrl(element: string, dataList?: string): string {
    if (this.config) {
      if (!dataList) {
        const urlWithElement = this.config[element] as string;
        return this.verifyUrl(urlWithElement)
      } else {
        const urlWithElement = (this.config[dataList] as Record<string, string>)[element];
        return this.verifyUrl(urlWithElement);
      }
    } else {
      return '';
    }
  }

  verifyUrl(typeModel: string): string {
    if (typeModel) {
      if (typeModel.includes('/', typeModel.length - 1)) {
        const typeRelease = typeModel;
        return typeRelease;
      } else {
        const newTipe = `${typeModel}/`;
        return newTipe;
      }
    }
    return '/';
  }

  getEndPoint(elementUrl: string, elementPath: string) {
    if (this.config) {
      const url = this.verifyUrl((this.config['URL'] as Record<string, string>)[elementUrl]);
      let path = this.verifyUrl((this.config['PATHS'] as Record<string, string>)[elementPath]);
      return url + path;
    } else {
      return '';
    }
  }

  getKey(key: string): string | null {
    const keys = this.config && (this.config["KEYS"] as Record<string, string>);
    if (keys && keys[key]) {
      return keys[key];
    }
    return null;
  }

  getUrlRaw(element: string, dataList?: string): string | null {
    if (this.config) {
      if (!dataList) {
        return (this.config[element] as string) || null;
      } else {
        return (this.config[dataList] as Record<string, string>)[element] || null;
      }
    } else {
      return null;
    }
  }
}
